import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { useState } from "react";
import { getAppState } from "../../../../../../../common/appState";
import { appsPublicImg } from "../../../../../../../common/consts";
import { spaceBetween } from "../../../../../../../common/util/Array/spaceBetween";
import { PresentBoxKey } from "../../../../../../zApps/Layout/Login/MyPage/components/OpenableCards/ItemsCard/items/ItemClass/PresentBox";
import { RegisteredEnvelopeKey } from "../../../../../../zApps/Layout/Login/MyPage/components/OpenableCards/ItemsCard/items/ItemClass/RegisteredEnvelope/RegisteredEnvelope";
import ShurikenProgress from "../../../../../Animations/ShurikenProgress";
import { PrimaryButton } from "../../../../../Button/PrimaryButton";

export function TheirPresent({
    isOpen,
    present,
    presentQuantity,
    openPresent,
    globalSubmitting,
    setGlobalSubmitting,
}: {
    isOpen?: boolean;
    present: PresentBoxKey | RegisteredEnvelopeKey;
    presentQuantity: number;
    openPresent: () => Promise<void>;
    globalSubmitting?: boolean;
    setGlobalSubmitting?: (submitting: boolean) => void;
}) {
    const c = useStyles();
    const [localSubmitting, setLocalSubmitting] = useState(false);
    const setSubmitting = (newSubmitting: boolean) => {
        setGlobalSubmitting?.(newSubmitting);
        setLocalSubmitting(newSubmitting);
    };

    return (
        <div className={c.outerContainer}>
            <Card className={spaceBetween(c.card)}>
                <div className={c.imgAndQuantity}>
                    <img
                        src={`${appsPublicImg}item/${present}.png`}
                        className={c.img}
                    />
                    {presentQuantity > 1 &&
                        present !== "registered_envelope" && (
                            <div className={c.quantity}>
                                × {presentQuantity}
                            </div>
                        )}
                </div>

                <PrimaryButton
                    disabled={isOpen || globalSubmitting}
                    className={c.button}
                    fullWidth
                    onClick={async () => {
                        setSubmitting(true);
                        const { user } = getAppState();
                        if (!user) {
                            setSubmitting(false);
                            return;
                        }
                        await openPresent();
                        setSubmitting(false);
                    }}
                >
                    {localSubmitting ? (
                        <ShurikenProgress size={20} style={{ padding: 5 }} />
                    ) : (
                        "Open!"
                    )}
                </PrimaryButton>
            </Card>
        </div>
    );
}
const useStyles = makeStyles({
    outerContainer: { marginTop: 15, display: "flex" },
    card: { display: "flex", padding: 10, width: "100%", alignItems: "center" },
    imgAndQuantity: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "0 5px",
    },
    img: { width: 40 },
    quantity: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
    },
    button: {
        marginLeft: 10,
    },
});
